<script>
  //import ImageList from './gallery_image_list.svelte';
  //import Image from './gallery_image.svelte';
  import GallerySelect from './../../../components/gallery/gallery_select.svelte';
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import request from 'superagent';
  
  import { link } from "svelte-routing";
  
  export let id = null;
  export let lang = 'cs';
  export let imageIndex = 0;
  const defaultGallery = {
    profile: {id: null, name: {[lang]: ""}, about: {[lang]: ""}, galleries: [], data: {}},
    active: null,
    images: []
  }
  
  let name = "", about = "";
  let profile = {galleries: [], data: {}};
  let gallery = Object.assign({}, defaultGallery);
  let activeImage = null;
  
  $: owner = gallery.profile_id
  $: activeImage = gallery.images[imageIndex];
  $: ownerGalleriesCount = profile.galleries.length;
  
  function fetchOwner() {
    if (!gallery.profile_id)
      return;
    fetch(`/user/${gallery.profile_id}.jsr`)
      .then(r => r.json())
      .then(data => {
        let newVal = data.data[0];
        newVal.name  = JSON.parse(newVal.name);
        newVal.about = JSON.parse(newVal.about);
        newVal.data  = JSON.parse(newVal.data);
        newVal.galleries  = JSON.parse(newVal.galleries);
        profile = Object.assign({}, defaultGallery.profile, newVal.data, newVal);
        console.log(profile);
        console.log(data);
      });
  }
  
  
  function load() {
    if (id != null) {
      request.get(`/gallery/galleries/${id}.json`)
      .then(resp => {
        gallery = Object.assign({}, defaultGallery, resp.body);
        name = gallery.name[lang];
        about = gallery.about[lang];
        fetchOwner();
      });
    }
  }
  
  function replaceByOther(ngi) {
    id = ngi.detail;
    load();
  }
  
  onMount(load);
</script>

{#if id}
<div class='row'>
<div class='col-12 my-2 text-center'>
{#if activeImage}
{#if activeImage.name}
<h2>{activeImage.name[lang] || ""}</h2>
{/if}
{#if activeImage.about}
<p>{activeImage.about[lang]|| ""}</p>
{/if}
<img alt='{activeImage.name[lang]}' class='img-fluid' src='/i/600/600/{activeImage.image}' title='{activeImage.name[lang]}'>
{/if}
</div>
</div>
<div class='row flex-nowrap scrolli'>
<div class='col-12'>
{#each gallery.images as {name, image}, i}
<div class='image d-inline-block py-2 mx-1' on:click='{() => { if(imageIndex == i) return; activeImage = null; imageIndex = i; } }'>
<img alt='{name[lang]}' class:active='{imageIndex==i}' src='/i/100/100/{image}'>
</div>
{/each}
</div>
</div>
{/if}

